const passengers = {
  passengers: 'נוסעים',
  passengerTypes: {
    default: 'ברירת מחדל',
    student: 'תלמיד',
    employee: 'עובד',
    caregiver: 'מטפל',
  },
  headerButtons: {
    create: {
      createBtn: 'הוסף',
      employee: 'עובד',
      student: 'תלמיד',
    },

    import: 'ייבא',
  },

  toast: {
    error: {
      badResponse: '[נוסעים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      resetSuccess: 'דוא"ל לאיפוס סיסמה נשלח בהצלחה.',
      create: {
        default: '[נוסעים]  נוצר',
      },
      edit: {
        default: '[נוסעים] עודכן',
      },
      delete: {
        default: '[נוסעים] נמחק בהצלחה',
      },
    },
    alreadyExistToast: {
      messages: {
        phone: 'מספר הטלפון כבר בשימוש על ידי נוסע אחר',
        email: 'אימייל כבר בשימוש על ידי נוסע אחר',
      },
    },
  },

  deleteModal: {
    header: 'מחק נוסעים',
    body: 'אתה עומד למחוק {{num}} נוסעים.',
  },

  create: {
    successToast: {
      message: 'הצלחה! נוסע נוצר בהצלחה',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן ליצור נוסע!',
    },
  },

  update: {
    successToast: {
      message: 'הצלחה! נוסע עודכן בהצלחה',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן לעדכן נוסע!',
    },
  },

  edit: {
    tabs: {
      information: 'מידע כללי',
      notes: 'הערות',
      history: 'היסטוריה',
      bookingHistory: 'היסטוריית הזמנות',
    },
    modalRemoveConfirm: {
      header: 'אזהרה!',
      body: 'האם אתה בטוח שברצונך למחוק נוסע זה?',
      modalRemoveConfirmBtnConfirm: 'מחק',
    },
    activeStatus: {
      statusActive: 'פעיל',
      statusDeactivate: 'לא פעיל',
    },
    suspend: {
      actionActivate: 'בטל השעיה',
      actionDeactivate: 'השעיה',
      suspendModal: {
        popupTitleDeactivation: 'השעיית נוסע',
        popupTitleActive: 'סיבת השעיה',
        popupTitleUnsuspend: 'סיבת ביטול השעיה',
        popupSubTitleDeactivation: 'בחר את סיבת ההשעיה',
        popupActionActive: 'בטל השעיית נוסע',
        popupActionDeactivate: 'השעיית נוסע',
      },
    },
  },

  table: {
    filters: {
      facility: 'מתקן',
      type: 'סוג',
      attributes: 'מאפיינים',
    },
    headers: {
      name: 'שם',
      type: 'סוג',
      email: 'אימייל',
      created: 'תאריך יצירה',
      id: 'מזהה',
      profile: 'פרופיל',
      supplier: 'ספק',
      phone: 'טלפון',
      createdBy: 'נוצר על ידי',
      baseAddress: 'כתובת בית',
      occupationAddress: 'כתובת משרד',
      attributes: 'מאפיינים',
    },
    passengersGettExtraHeaders: {
      home: 'בית',
      home2: 'בית 2',
      work: 'עבודה',
      site: 'אתר',
    },
    empty: 'ריק',
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  forms: {
    header: {
      createPassenger: {
        title: 'הוסף',
      },

      updatePassenger: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      profile: {
        header: 'פרופיל',
        fields: {
          profile: 'פרופיל',
        },
      },
      supplier: {
        header: 'ספק',
        fields: {
          label: 'ספק מועדף',
        },
      },
      attributes: {
        header: 'מאפיינים',
        fields: {
          label: 'מאפיינים',
        },
      },
      paymentTypes: {
        header: 'סוגי תשלום',
        fields: {
          membership: 'חברות',
        },
        actions: {
          save: 'שמור',
        },
      },
      details: {
        header: 'פרטים אישיים',
        fields: {
          firstName: 'שם פרטי',
          lastName: 'שם משפחה',
          email: 'אימייל',
          phone: 'טלפון',
          ada: 'עדה',
          additionalPhone: 'טלפון נוסף',
          code: 'קוד',
        },
      },
      address: {
        header: 'כתובת נוסע',
        sharedValues: {
          manual: 'כתובת ידנית',
        },
        fields: {
          homeAddress: {
            label: 'כתובת בית',
          },
          homeAddress2: {
            label: 'כתובת בית 2',
          },
          officeAddress: {
            label: 'כתובת משרד',
          },
          workAddress: {
            label: 'כתובת עבודה',
          },
        },
      },
      actions: {
        header: 'פעולות',
        buttons: {
          delete: 'מחק',
          resetPassword: 'איפוס סיסמה',
        },
      },
      health: {
        header: 'מידע רפואי',
        fields: {
          certificationDate: 'תאריך הסמכה',
          expirationDate: 'תאריך תפוגה',
          disabilityAidTools: 'כלי עזר לנכים',
        },
      },
      caregiverInfo: {
        header: 'מידע על מטפל',
        fields: {
          caregiverFirstName: 'שם פרטי',
          caregiverLastName: 'שם משפחה',
          caregiverEmail: 'אימייל',
          caregiverPhone: 'טלפון',
        },
      },
      jobClusters: {
        header: 'אשכולות הזמנות',
        fields: {
          limitedMobility: 'מוגבלות בתנועה',
        },
        information: {
          limitedMobility: 'המערכת תתעלם מ"מרחק מקסימלי" ותבחר את נקודת האיסוף/ההורדה הקרובה ביותר לכתובת הנוסע',
        }
      },
    },
    jobHistory: {
      header: 'היסטוריית הזמנות',
      popupInfo: {
        date: 'זמן איסוף מבוקש: {{time}}',
        header: 'מידע על הזמנה',
        from: 'מ:',
        to: 'אל:'
      }
    },

    validations: {
      firstName: 'שם פרטי נדרש',
      lastName: 'שם משפחה נדרש',
      profiles: 'פרופילים נדרשים',
      email: {
        required: 'אימייל נדרש',
        email: 'כתובת אימייל לא חוקית',
      },
      unit: {
        required: 'אתר נדרש',
      },
    },
  },

  statuses: {
    onATrip: 'נוסעים בנסיעה',
    completed: 'נוסעים שסיימו נסיעות',
    created: 'נוסעים שנוצרו (מ-{{hourFrom}})',
  },

  totalPassengers: 'סה"כ נוסעים',
};

export default passengers;
